/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: SelectControlInput.tsx
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 1743
 * ---
 * Description:
 */

import { Editor }                     from '../../../store/observables/Editor';
import { ChildControlFieldProps } from './ShapeControlView';
import {
  SelectSCItem
}                                 from '../../../common/controls/helpers/SelectShapeControl';
import { ShapeControlWrapper }    from './ShapeControlWrapper';
import { ItemRenderer, Select }       from '@blueprintjs/select';
import { Button, IconName, MenuItem } from '@blueprintjs/core';
import React, { useEffect, useState } from 'react';

interface Props {
  editor: Editor;
}

const StringSelect = Select.ofType<string>();

export const SelectControlInput = (props: ChildControlFieldProps<string> & { items: SelectSCItem<string>[], icon: IconName }) => {
  const [selectedItem, setSelectedItem] = useState('');

  useEffect(() => {
    setSelectedItem(props.observableValue);
  }, [props.label]);

  const itemRenderer: ItemRenderer<string> = (item, {
    handleClick,
    modifiers,
  }) => {
    const t = props.items.find(it => it.value === item);
    if (!modifiers.matchesPredicate)
      return null;
    return <MenuItem
      key={ t?.value }
      active={ modifiers.active }
      disabled={ modifiers.disabled }
      label={ t?.value }
      text={ t?.value }
      onClick={ handleClick }
    />;
  };

  const itemSelect = (item: string) => {
    props.setter(item);
    setSelectedItem(item);
  };

  return (<ShapeControlWrapper label={ props.label }
                               labelInfo={ props.labelInfo }>
    <StringSelect items={ props.items.map(it => it.value) }
                  filterable={ true }
                  itemRenderer={ itemRenderer }
                  onItemSelect={ itemSelect }>
      <Button
        icon={ props.icon }
        rightIcon="caret-down"
        text={ selectedItem ? selectedItem : '(nessuna selezione)' }
      />
    </StringSelect>
  </ShapeControlWrapper>);
};